<div class="article">
  <div class="container">
    <div>
      <h1>{{ userDetails | fullName }}</h1>
    </div>
  </div>

  <div>
    <form class="d-flex" [formGroup]="profileForm">
      <mat-form-field appearance="fill" class="form-field mr-10">
        <mat-label>User Id</mat-label>
        <input matInput formControlName="user_id" [disabled]="true" />
      </mat-form-field>

      @if (userDetails?.npi) {
        <mat-form-field appearance="fill" class="form-field mr-10">
          <mat-label>NPI Number</mat-label>
          <input matInput formControlName="npi" [disabled]="true" />
        </mat-form-field>
      }
    </form>
  </div>
  <div>
    <p>
      To change your first name, last name, or email, please contact WCG Client
      Care via our
      <a href="#" (click)="contactClientCare(); $event.preventDefault()"
        >help chat.</a
      >
    </p>
  </div>
  @if (false) {
    <div class="row">
      <div class="col-1-of-3">
        <contacts
          (emitContactEvent)="emitContactEvent($event)"
          [contactInfo]="emailAddresses"
        ></contacts>
        <br />
        <contacts
          (emitContactEvent)="emitContactEvent($event)"
          [contactInfo]="phoneNumbers"
        ></contacts>
        <br />
        <contacts
          (emitContactEvent)="emitContactEvent($event)"
          [contactInfo]="specializations"
        ></contacts
        ><br />
        <contacts
          (emitContactEvent)="emitContactEvent($event)"
          [contactInfo]="degrees"
        ></contacts>
      </div>
      <div class="col-2-of-3">
        <contacts
          (emitContactEvent)="emitContactEvent($event)"
          [contactInfo]="mailingAddresses"
        ></contacts>
        <br />
        <contacts
          (emitContactEvent)="emitContactEvent($event)"
          [contactInfo]="studyFacilities"
        ></contacts>
        <br />
        <contacts
          (emitContactEvent)="emitContactEvent($event)"
          [contactInfo]="companies"
        ></contacts>
      </div>
    </div>
  }
</div>
